import React, {useState, useEffect} from 'react'
import {Modal, Input, Form, Upload, Icon} from 'antd'
import common from '@/public/common'
import get from 'lodash/get'

const AddQrcodeModal = props => {

  const {form, brandId, onClose, visible, editQrcodeObj} = props

  const [fileList, setFileList] = useState([])

  useEffect(() => {
    if (editQrcodeObj) {
      const {qy_user_id, qr_code_pic, qy_nick} = editQrcodeObj

      let list = (qr_code_pic || []).map((item, index) => {
        return {
          url:item.url, uid:index
        }
      })
      setFileList(list)

      form.setFieldsValue({
        qy_user_id, qr_code_pic: [...list], qy_nick
      })
    }
  }, [])


  const handleChange = ({ file, fileList }) => {
    setFileList(fileList)
  }

  const saveQrcode = async () => {
    const values = await form.validateFields() 

    let qrCodePicArr = []

    values.qr_code_pic.map(item => {
      if (item.response && item.response.pic_url || item.url) {
        qrCodePicArr.push(item.url || item.response.pic_url)
      }
    })

    let params = {
      ...values, 
      qr_code_pic: get(qrCodePicArr, [0], ''),
      brand_id: brandId
    }

    if (editQrcodeObj) {
      params.id = editQrcodeObj.id
    }

    props.sumbit(params)
  }

  const uploadButton = (
    <div>
      <Icon type='plus' />
      <div className="ant-upload-text">上传</div>
    </div>
  )

  return (
    <Modal 
      title={`${editQrcodeObj ? '编辑' : '添加'}企微活码`}
      visible={visible}
      onOk={saveQrcode}
      onCancel={onClose}
    >
      <Form layout="inline">
        <Form.Item label="企微账号" style={{marginBottom: '16px'}}>
          {form.getFieldDecorator('qy_user_id', {
            rules: [
              {
                required: true,
                message: '请输入企微账号',
              },
            ]
          })(
            <Input placeholder="请输入" style={{ width: 320 }}  />
          )}
        </Form.Item>
        <Form.Item label="企微昵称" style={{marginBottom: '16px',marginLeft: '8px'}}>
          {form.getFieldDecorator('qy_nick')(
            <Input placeholder="请输入" style={{ width: 320 }}  />
          )}
        </Form.Item>
        <Form.Item label="企微活码">
          {form.getFieldDecorator('qr_code_pic', {
            valuePropName: 'fileList',
            getValueFromEvent: e => {
              if (Array.isArray(e)) {
                return e
              }
              return e && e.fileList
            },
            rules: [
              {
                required: true,
                message: '请上传企微活码',
              }
            ]
          })(
            <Upload 
              listType="picture-card"
              action={`${common.javaBase_url}brandwx/qrcode/uploadpic`}
              data={file => {
                return {
                  brandId,
                  file: file
                }
              }}
              onChange={handleChange}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          )}
        </Form.Item>
      </Form>
    </Modal>
  )

}

export default Form.create()(AddQrcodeModal)


// WEBPACK FOOTER //
// ./src/pages/brandwx/AddQrcodeModal.js